import { QueryOptions } from "../components/Common/useQuery";
import useUserQuery from "../components/Common/useUserQuery";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export enum ConnectionStatus {
  Connected = 'Connected',
  Pending = 'Pending',
  Declined = 'Declined',
  Revoked = 'Revoked',
  Expired = 'Expired',
  Multiple = 'Multiple'
}

export enum Direction {
  Source = 'Source',
  Partner = 'Partner',
}

export interface DataSharingConnection {
  id: string;
  direction: Direction;
  status: ConnectionStatus;
  otherSiteId?: string;
  otherSiteName?: string;
  otherBusinessName?: string;
  otherAdminEmail?: string;
  createdAt: string;
  acceptedAt?: string;
  declinedAt?: string;
  revokedAt?: string;
  expiresAt?: string;
}

export interface DataSharingSiteDto {
  siteId: string;
  siteName: string;
  connections: DataSharingConnection[];
}

const useGetDataSharingConnections = (options?: QueryOptions<DataSharingSiteDto[]>) => {
  const business = useSelectedBusiness();
  return useUserQuery<DataSharingSiteDto[]>({ path: `/api/businesses/${business.id}/dataSharing/connections` }, options);
}

export default useGetDataSharingConnections;